"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const MinorityOwned = createSVGIcon(
  <>
    <circle cx="13.033" cy="9.5" r="6.5" fill="#E8E1D2" />
    <path
      d="M21.066 18c-3.176 0-3.176-2.6-6.357-2.6-3.176 0-3.176 2.6-6.352 2.6C5.176 18 5.176 15.4 2 15.4M21.066 13.8c-3.176 0-3.176-2.6-6.357-2.6-3.176 0-3.176 2.6-6.352 2.6-3.181 0-3.181-2.6-6.357-2.6"
      stroke="#312921"
      strokeMiterlimit="10"
    />
  </>,
  "Minority owned",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    className: legacyIconCls(),
  }
);
